module.exports = __webpack_public_path__ + "static/media/ic_addBlack.3b7ad9a9.svg";